import {Accordion, AccordionSummary, Typography} from "@material-ui/core"
import {Language as LanguageIcon} from "@material-ui/icons"
import React from "react"
import styled from "styled-components"

import {CustomerPreferredLanguageConfiguredActivityPayload} from "@indebted/api"

function PreferredLanguageConfiguredActivity(
	panelId: number,
	{
		Title,
		HappenedAt,
	}: {Title: string; HappenedAt: string; Payload: CustomerPreferredLanguageConfiguredActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => void,
	classes: {summary: string},
) {
	return (
		<AccordionNoContent expanded={false}>
			<AccordionSummary>
				<LanguageIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
		</AccordionNoContent>
	)
}

const AccordionNoContent = styled(Accordion)`
	.MuiAccordionSummary-content {
		cursor: default;
	}
`

export {PreferredLanguageConfiguredActivity}
